import { createContext, useContext } from "react";
import { getLink } from "links";

export type NavigationLinks = typeof getLink;

const NavigationContext = createContext<NavigationLinks>(getLink);

export const useNavigationLinks = () => useContext(NavigationContext);
